import React from "react";
import ContentLayout from "../../../../../partials/content/ContentLayout";
import VisitDetailContent from "./VisitDetailContent";
function VisitDetail({ match, history }) {
  const visitID = match.params.visitID;
  console.log("visitID", visitID);
  return (
    <React.Fragment>
      <ContentLayout>
        <VisitDetailContent
          appCode="SLJO"
          visitID={visitID}
          history={history}
        />
      </ContentLayout>
    </React.Fragment>
  );
}

export default VisitDetail;
